<template>
  <div>
    <a-modal
      :title="audit ? '付款审批' : '付款申请详情'"
      class="gufiiguy"
      :visible="is_show"
      width="60%"
      @cancel="is_show = false"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button v-if="typeDetail == 1" type="primary" @click="downloadFile" style="float: left"> 导出</a-button>
        <a-button type="primary" @click="downloadData" style="float: left" v-else> 导出 </a-button>
        <a-button key="back" @click="is_show = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
      </template>
      <div v-if="typeDetail == 1" >
        <newPaymentModelDetail ref="newPaymentModelDetail" @getLoading="getLoading"></newPaymentModelDetail>
      </div>
      <div ref="sadsada" v-if="typeDetail != 1">
        <a-form-model :model="info" :label-col="labelCol" :wrapper-col="wrapperCol">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批标题"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="抄送人"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.ccName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批编号"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.paymentCode }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="标    题" class="model_span_form">
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="隶属公司" class="model_span_form">
                  <span>{{ info.subjectionCompanyName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="隶属部门" class="model_span_form">
                  <span>{{ info.subjectionDeptName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <span v-for="(item, index) in info.applyList" :key="index" class="auditItem">
                    <span @click="handelAudit(item)">{{ item.associateTitle }}</span>
                  </span>
                </a-form-model-item>
              </a-col>
            </a-row>
             <a-row>
               <a-col :span="24">
              <a-form-model-item label="关联采购" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span v-for="(item, index) in info.purchaseList" :key="index" class="auditItem">
                  <span @click="handelAudit(item)">{{ item.associateTitle }}</span>
                </span>
              </a-form-model-item>
            </a-col>
             </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="款项类目" class="model_span_form">
                  <span>{{ payMentTypes[info.projectType] }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="项目名称" class="model_span_form">
                  <span>{{ info.projectName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="项目总金额" class="model_span_form">
                  <span>{{ info.projectMoney }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="项目编号" class="model_span_form">
                  <span>{{ info.projectCode }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="已付金额" class="model_span_form">
                  <span>{{ info.paidCount }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="本次付款总金额" class="model_span_form">
                  <span>{{ info.payCount }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="备注"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.remark }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="特殊备注"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.remarkSpec }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="账户类型" class="model_span_form">
                  <span>{{ info.accountTypeName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="户名" class="model_span_form">
                  <span>{{ info.name }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="账号" class="model_span_form">
                  <span>{{ info.accountNum }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8" v-if="info.accountType == 2 || info.accountType == 3">
                <a-form-model-item label="开户行" class="model_span_form">
                  <span>{{ info.bank }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="info.accountType == 3">
                <a-form-model-item label="地址" class="model_span_form">
                  <span>{{ info.provinceName }}{{ info.cityName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="info.accountType == 3">
                <a-form-model-item label="银行支行" class="model_span_form">
                  <span>{{ info.branchBank }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path"
                    @click="previewFile(item)"
                    v-for="(item, index) in info.attachment"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="报销凭证" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path_img"
                    v-for="(item, index) in info.vouchers"
                    :key="index"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item.preUrl" @click="show_img(index, info.vouchers)" />
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div v-for="(item, index) in info.paymentDetails" :key="index">
            <div class="title">
              <span>付款明细{{ index + 1 }}</span>
            </div>
            <div class="content">
              <a-row>
                <a-col :span="8">
                  <a-form-model-item label="本次支付金额" class="model_span_form">
                    <span>{{ item.thisPayment }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item label="电子发票" class="model_span_form">
                    <span>{{ item.invoice }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="8">
                  <a-form-model-item label="费用明细" class="model_span_form">
                    <span>{{ item.remark }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="title" v-if="!audit && recordNumber == 1">
            <span>审批记录</span>
          </div>
          <div class="content" v-if="!audit && recordNumber == 1">
            <auditModel ref="auditModel"></auditModel>
          </div>
          <!-- <a-row>
					<a-col :span="12" v-if="audit">
						<a-form-model-item label="审批意见" style="margin-top: 25px">
							<a-textarea placeholder="请输入" v-model="comment" :auto-size="{ minRows: 2, maxRows: 6 }" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12" v-if="record.comment != undefined">
						<a-form-model-item label="审批意见" style="margin-top: 25px">
							{{ record.comment }}
						</a-form-model-item>
					</a-col>
				</a-row> -->
        </a-form-model>
      </div>
      <preview ref="preview" />
      <!-- 撤销提示 -->
      <a-modal
        v-model="is_revocation"
        :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
        on-ok="handleOkReason"
      >
        <template slot="footer">
          <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
            驳回
          </a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
            通过
          </a-button>
        </template>
        <a-textarea placeholder="请输入原因" v-model="comment" />
      </a-modal>
    </a-modal>
    <business-modal ref="modal" @ok="handleOk" />
    <leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
    <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" :typeStyle="typeStyle" :rowId="rowId"/>
    <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
    <receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
    <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
    <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
    <reimbursement-modal2 ref="reimbursementmodal" @ok="handleOk" :audit="false" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" :audit="false" />
    <payMentModal2 ref="paymentmodal" :audit="false" />
    <transferModal ref="transferModal" @sure="handleSure" />
    <sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
    <currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
    <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
    <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
    <returncar-modal2 ref="returncarmodal" @ok="handleOk" :audit="false" />
    <charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
    <salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
    <adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
    <other-modal ref="othermodal" @ok="handleOk" :audit="false" />
    <feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
  
  </div>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import { getPaymentDetail } from '@/api/financial'
import { get_process_all } from '@/api/activiti'
import { downLoadWordPost } from '@/utils/index'
import newPaymentModelDetail from './newPaymentModelDetail.vue'
import auditModel from './audit.vue'
import { download_file_java } from '@/utils/request'
import { resolveBlob } from '@/utils/index'
import { axios } from '@/utils/request'
import { previewFileLists } from '@/utils/preview.js'
import { payment_apply_get } from '@/api/financial'
import { act_task_audit, payment_apply_downlodPdf, modalMap } from '@/api/activiti'
import preview from '@/components/module/prview'
import BusinessModal from '@/views/activiti/modules/BusinessModal.vue'
import LeaveModal from '@/views/activiti/modules/LeaveModal.vue'
import PurchaseModal from '@/views/activiti/modules/PurchaseModal.vue'
import ScrapModal from '@/views/activiti/modules/ScrapModal.vue'
import receiveModal from '@/views/activiti/modules/receiveModal.vue'
import OperationModal from '@/views/activiti/modules/OperationModal.vue'
import ServiceModal from '@/views/activiti/modules/ServiceModal.vue'
import payMentModal2 from '@/views/activiti/modules/payMentModal2.vue'
import ReimbursementModal2 from '@/views/activiti/modules/ReimbursementModal2.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal2 from '@/views/activiti/modules/returncarModal2.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
import Watermark from '../../../utils/watermark'
 const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
export default {
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    BusinessModal,
    LeaveModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal2,
    contractModal,
    payMentModal2,
    transferModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal2,
    chargeModal,
    salaryModal,
    adjustmentModal,
    otherModal,
    feedbackModal,
    auditModel,
    newPaymentModelDetail
  },
  data() {
    return {
      informationData: '',
      dataList: '',
      loading: false,
      typeDetail: 0,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      is_show: false,
      info: {},
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      record: null,
      typeStyle: 2,
      rowId: undefined,
      timeout: null
    }
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    	//导出
		downloadData() {
			downLoadPdf('/act/payment_apply/downlodPdf?businessKey=' + this.record.businessKey,)
    },
    getLoading(data) {
      this.loading = data

    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    handelAudit(item) {
      console.log(item, 'itemmmmmmmmmmmmmmmmmmmmmm')
       this.typeStyle = 2
      const modal = modalMap[item.associateTypes]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: item.associateApply,
      })
    }, //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },
    //预览文件
    // previewFile(file) {
    //   //    previewFile(file) {
    //   let path = '/' + file.url.split('/')[0] + '/'
    //   let fileName = file.url.substring(file.url.indexOf('/') + 1)
    //   axios({
    //     url: `/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
    //     method: 'post',
    //     responseType: 'blob', // 必须要写 // headers: { //  'Content-Type': 'application/json;charset=UTF-8' // }
    //   }).then((res) => {
    //     this.imgUrl = window.URL.createObjectURL(res)
    //     resolveBlob({
    //       data: res,
    //       headers: {
    //         'content-disposition': `attachment;filename=${fileName}`,
    //       },
    //     }) //新窗口打开，借用浏览器去打印
    //   }) // window.open(file.preUrl)
    //   //             },

    //   // console.log(file)
    //   // window.open(file.preUrl)
    // },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    download() {
      payment_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
         window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    },
    downloadFile() {
       Object.assign(this.informationData, {
        processData: this.dataList
      })
       downLoadWordPost( '/external/oa_non_a/docx_generate/approval', 
        this.informationData,
      )

    },
    getData(row, procDefKey) {
       get_process_all({
					procInstId: row.procInstId,
					name: procDefKey,
					userId: this.$store.getters.userId,
				}).then((res) => {
          if(res.code == 200) {
              this.dataList = res.data
             getPaymentDetail(row.businessKey).then((res) => {
               if (res.code == 200) {
                this.informationData =  JSON.parse(JSON.stringify(res.data))
                }
             })
          }
        })

    },
    show(record, type = null) {
      this.typeDetail = 0
      if(record.processDefKey) {
         this.record = record
         var fdStart =  record.processDefKey.indexOf("payment-");
         this.getData(record, record.processDefKey)

      } else if(record.procDefKey){
         this.record = record
         var fdStart =  record.procDefKey.indexOf("payment-");
         this.getData(record, record.procDefKey)
      }
      if(fdStart == 0) {
        this.typeDetail = 1
        this.is_show = true
        console.log(this.typeDetail, 'this.typeDetail=====================')
        setTimeout(() => {
          // this.loading = true
            console.log( this.$refs, ' this.$refs.newPaymentModelDetail===========================')
          this.$refs.newPaymentModelDetail.init(record)
        },100)
      } else {
        this.recordNumber = record.recordNumber
      console.log(this.record)
      payment_apply_get(record.businessKey).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
          // const { type } = res.data
          var purchaseList = []
          var applyList = []
          this.info = res.data
          this.rowId = res.data

          // this.mdl = Object.assign(res.data)
          this.info.associatePurchaseApply.forEach(item => {
            console.log(item, 'item======')
            if(item.associateTypes == "purchase") {
              purchaseList.push(item)
            } else {
              applyList.push(item)
            }
          })
          Object.assign(this.info, {
            purchaseList: purchaseList,
            applyList: applyList

          })
          console.log( this.info, ' this.info this.info this.info this.info this.info this.info this.info')
        previewFileLists(this.info.attachment).then((res) => {
          this.info.attachment = res
        })
        this.is_show = true
        this.$nextTick(() => {
          Watermark.set('安联云管家', this.$refs.sadsada)
           if(!this.audit && this.recordNumber == 1) {
                 this.$refs.auditModel.show(record)
               }
        })
      })

      }
      
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
           clearTimeout(this.timeout)
         console.log(this.timeout, 'this.timeout==========================')
          this.timeout = setTimeout(() => {
            //通过审批
           this.actTask()
         }, 1000)
          // this.actTask()
        }
      } else if (this.result == 2) {
         clearTimeout(this.timeout)
         console.log(this.timeout, 'this.timeout==========================')
          this.timeout = setTimeout(() => {
            //通过审批
           this.actTask()
         }, 1000)
       
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
         taskDefKey: this.record.taskDefKey
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
    succeed() {},
  },
}
</script>
<style>
.auditItem {
  border-radius: 5px;
  background-color: #f8f8f8;
  margin-left: 10px;
  color: dodgerblue;
  padding: 10px;
}
</style>
